import { createFileRoute, redirect } from '@tanstack/react-router'

/** The sidebar "Store Settings" entry lands on Profil Toko. */
export const Route = createFileRoute('/_authed/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/store', replace: true })
  },
})
